import { Component } from '@theme/component';
import { matchesSearch } from '@theme/medorra-quote-core';

/** @extends {Component<{query:HTMLInputElement,department:HTMLSelectElement,controls:HTMLElement,status:HTMLElement,empty:HTMLElement}>} */
class MedorraCatalogSearch extends Component {
  requiredRefs = ['query', 'controls', 'status', 'empty'];
  #controller;
  connectedCallback() {
    super.connectedCallback(); this.#controller = new AbortController();
    this.refs.controls.hidden = false;
    const params = new URL(location.href).searchParams;
    this.refs.query.value = params.get('q') || '';
    if (this.refs.department) this.refs.department.value = params.get('department') || '';
    document.addEventListener('shopify:section:load', () => this.filter(), { signal: this.#controller.signal });
    this.filter();
    if (location.hash === '#catalog-search') this.refs.query.focus({ preventScroll: true });
  }
  updatedCallback() { super.updatedCallback(); this.refs.controls.hidden = false; this.filter(); }
  disconnectedCallback() { this.#controller?.abort(); super.disconnectedCallback(); }
  filter() {
    const scope = this.closest('main'); if (!scope) return;
    const query = this.refs.query.value;
    const department = this.refs.department?.value || "";
    let count = 0;
    for (const group of scope.querySelectorAll('[data-medorra-department]')) {
      let matches = 0;
      for (const card of group.querySelectorAll('[data-medorra-product]')) {
        card.hidden = Boolean(department && group.id !== department) || !matchesSearch(card.dataset.medorraProduct || '', query);
        if (!card.hidden) matches++;
      }
      group.hidden = Boolean(query.trim() || department) && matches === 0;
      count += matches;
    }
    this.refs.status.textContent = (this.dataset.countLabel || '').replace('__count__', String(count));
    this.refs.empty.hidden = count > 0;
    const url = new URL(location.href);
    if (query.trim()) url.searchParams.set('q', query.trim()); else url.searchParams.delete('q');
    if (department) url.searchParams.set('department', department); else url.searchParams.delete('department');
    history.replaceState(null, '', url);
  }
  clear() { this.refs.query.value = ''; if (this.refs.department) this.refs.department.value = ''; this.filter(); }
}
/** @extends {Component<{product:HTMLInputElement}>} */
class MedorraProductInquiry extends Component {
  connectedCallback() {
    super.connectedCallback(); const field = this.refs.product; if (!field || field.value) return;
    const product = new URL(location.href).searchParams.get('product');
    if (product) field.value = product.slice(0, 240);
  }
}
if (!customElements.get('medorra-catalog-search')) customElements.define('medorra-catalog-search', MedorraCatalogSearch);
if (!customElements.get('medorra-product-inquiry')) customElements.define('medorra-product-inquiry', MedorraProductInquiry);
